export const AboutSectionFieldLimits = {
  heading: {
    min: 1,
    max: 100,
  },
  subheading: {
    min: 1,
    max: 150,
  },
  description: {
    min: 10,
    max: 1000,
  },
};